import LawSchoolInfo from './LawSchoolInfo';

export default LawSchoolInfo;
